import OrgName from 'components/Display/orgName';
import PropTypes from 'prop-types';
import React from 'react';

import Arrow from './arrow';

export default function ProjectHeader({
  expanded,
  toggleView,
  projectId,
  orgId,
}) {
  // Badge color is keyed off the project id prefix; non-string content
  // (e.g. a ProductDisplay element) always gets the product style.
  let badgeClass = 'product';
  if (typeof projectId === 'string') {
    if (projectId[0] === 'C') {
      badgeClass = 'customer';
    } else if (projectId[0] === 'P') {
      badgeClass = 'internal';
    }
  }
  return (
    <button
      type="button"
      className="projectHeader"
      onClick={toggleView}
    >
      <Arrow expanded={expanded} />
      <h3 className="info">
        <span className={`badge ${badgeClass}`}>
          {projectId}
        </span>
        <OrgName orgId={orgId} />
      </h3>
    </button>
  );
}

ProjectHeader.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleView: PropTypes.func.isRequired,
  projectId: PropTypes.node.isRequired,
  orgId: PropTypes.string.isRequired,
};
